import { Box, IconButton, Typography } from '@mui/material'
import React from 'react'
import Progress from '../../../shared/components/common/Progress'
import { ArrowDropDown, Schedule, Pending, CheckCircleOutlineOutlined, ErrorOutlineOutlined, Error } from '@mui/icons-material'
import { Icons } from '../../../shared/utils/icons.jsx'
import { useUploadStatusListStore } from '../../store/uploadstatuslistdialog.store'
import { observer } from 'mobx-react'

const UploadsStatusList = observer( () => {

    const UploadStatusList = useUploadStatusListStore()

    return (
        <Box sx={{ position: "fixed", display: UploadStatusList.getAttachmentList.length > 0 ? "block" : "none", zIndex: 2000, borderRadius: "5px", background: "#fff", bottom: "0", right: "20px", boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)", minWidth: "200px", width: "300px", maxWidth: "350px" }}>
            <Box
                sx={{
                    display: "flex",
                    padding: "10px 20px",
                    alignItems: "center",
                    borderBottom: "1px solid #d3d3d3",
                    boxShadow: "0 1px 5px rgba(0,0,0,0.1)",
                    justifyContent: "space-between"
                }}>
                {UploadStatusList.getStatusList.filter( item => ( item.statusText === 'queued' || item.statusText === 'uploading' ) ).length > 0 ? <Typography variant="subtitle2">
                    Uploading {UploadStatusList.getStatusList.filter( item => ( item.statusText === 'queued' || item.statusText === 'uploading' ) ).length} items...
                </Typography> :
                    <Typography variant="subtitle2">
                        Upload completed
                    </Typography>
                }
                <IconButton size="small" onClick={() => UploadStatusList.closeDialog()}>
                    {!UploadStatusList.getDialogStatus ? <ArrowDropDown /> : Icons.default.CloseIcon}
                </IconButton>
            </Box>
            {UploadStatusList.getDialogStatus && <Box
                sx={{
                    maxHeight: "200px",
                    overflow: "auto"
                }}>
                {UploadStatusList.getStatusList.map( ( attachmentStatus, i ) => {
                    return (
                        <Box
                            key={i}
                            sx={{
                                borderTop: "2px solid rgba(0,0,0,0.1)",
                                fontSize: "14px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-betweeen",
                                gap: "5px",
                                padding: "10px 20px"
                            }}>
                            <Box
                                sx={{
                                    flexGrow: "1",
                                    display: "flex",
                                    flexDirection: "column"
                                }}>
                                <Typography
                                    noWrap
                                    sx={{
                                        fontSize: "12px",
                                        width: "150px"
                                    }}><b>{`${UploadStatusList.getAttachmentList[i]?.name}.${UploadStatusList.getAttachmentList[i]?.ext}`}</b></Typography>
                                <Typography
                                    noWrap
                                    sx={{
                                        fontSize: "10px",
                                        width: "150px"
                                    }}> to <b>{UploadStatusList.getAttachmentList[i]?.module.module_name}</b></Typography>
                                <Typography
                                    noWrap
                                    sx={{
                                        fontSize: "12px",
                                        display: "flex",
                                        gap: "5px",
                                        alignItems: "center",
                                        width: "150px",
                                        textTransform: "capitalize",
                                        color: attachmentStatus?.statusText === 'queued' ? "primary.main" : attachmentStatus?.statusText === 'uploading' ? "orange" : attachmentStatus?.statusText === 'failed' ? "error.main" : "green"
                                    }}> {attachmentStatus?.statusText === 'queued' ? <Schedule sx={{ fontSize: "15px" }} /> : attachmentStatus?.statusText === 'uploading' ? <Pending sx={{ fontSize: "15px" }} /> : attachmentStatus?.statusText === 'failed' ? <ErrorOutlineOutlined sx={{ fontSize: "15px" }} /> : <CheckCircleOutlineOutlined sx={{ fontSize: "15px" }} />} {attachmentStatus.statusText}</Typography>
                            </Box>
                            {attachmentStatus?.statusText === 'failed' ? <Error color='error' sx={{ fontSize: "30px" }} /> : <Progress size={30} progress={( !attachmentStatus || !attachmentStatus.progress ) ? 0 : attachmentStatus.progress} />}
                        </Box>
                    );
                } )}
            </Box>}
        </Box>
    );
} )

export default UploadsStatusList
